import React from 'react';
import { Button } from 'antd';
import useAuth from '@/Hooks/useAuth';
import useLinkAccount, { AccountType } from '@/Hooks/useLinkAccount';
import { useLinkOrSubscribeModal } from '@/Hooks/useSubscription';
import redirectToLogin from '@/Utils/redirectToLogin';

interface Props {
  btnText: string;
  onClick?: () => void;
}

const PkgUpgradeBtn: React.FC<Props> = ({ btnText, onClick }) => {
  const { isAccountLinked } = useLinkAccount();
  const isSkyAccountLinked = isAccountLinked(AccountType.SkyDth);
  const { isAuthenticated } = useAuth();

  const showLinkOrSubscribeModal = useLinkOrSubscribeModal();

  const onBtnClick = () => {
    if (!isAuthenticated) {
      redirectToLogin();
    } else if (!isSkyAccountLinked) {
      showLinkOrSubscribeModal();
    } else {
      onClick?.();
    }
  };
  return (
    <Button type="primary" onClick={onBtnClick} name="Get package button">
      <span>{btnText}</span>
    </Button>
  );
};

export default PkgUpgradeBtn;
